/* Natural Rugs: always show every size (incl. runners) and, if a size
   doesn't come in the selected finish/care, switch to one that does. */
(function () {
  if (window.__nrSizeFix) return;
  window.__nrSizeFix = true;

  function esc(v) { return v.replace(/([ #;&,.+*~':"!^$[\]()=>|\/@])/g, '\\$1'); }

  function variantsFor(form) {
    var ta = form.querySelector('textarea[id^="VariantsJson-"]');
    if (!ta) return null;
    try { return JSON.parse(ta.value || ta.innerHTML); } catch (e) { return null; }
  }

  function group(form, idx) { return form.querySelector('.variant-input-wrap[data-index="option' + idx + '"]'); }

  function current(form, idx) {
    var g = group(form, idx);
    if (!g) return null;
    var sel = g.querySelector('select');
    if (sel) return sel.value;
    var r = g.querySelector('input[type="radio"]:checked');
    return r ? r.value : null;
  }

  function choose(form, idx, value) {
    var g = group(form, idx);
    if (!g) return;
    var el = g.querySelector('select');
    if (el) {
      var o = el.querySelector('option[value="' + esc(value) + '"]');
      if (o) o.disabled = false;
      el.value = value;
    } else {
      var w = g.querySelector('.variant-input[data-value="' + esc(value) + '"]');
      if (!w) return;
      el = w.querySelector('input');
      var lab = w.querySelector('label');
      el.disabled = false; el.checked = true;
      el.classList.remove('hide', 'disabled');
      if (lab) lab.classList.remove('hide', 'disabled');
    }
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function showAllSizes(form, variants) {
    var g = group(form, 1);
    if (!g) return;
    var seen = {};
    variants.forEach(function (v) { if (v.option1) seen[v.option1] = seen[v.option1] || v.available; });
    Object.keys(seen).forEach(function (val) {
      var sel = g.querySelector('select');
      if (sel) {
        var o = sel.querySelector('option[value="' + esc(val) + '"]');
        if (o) o.disabled = false;
        return;
      }
      var w = g.querySelector('.variant-input[data-value="' + esc(val) + '"]');
      if (!w) return;
      var i = w.querySelector('input'), l = w.querySelector('label');
      i.disabled = false;
      [i, l].forEach(function (n) { if (!n) return; n.classList.remove('hide', 'disabled'); if (!seen[val]) n.classList.add('disabled'); });
    });
  }

  function fix(form) {
    var variants = variantsFor(form);
    if (!variants || !variants.length || !group(form, 1) || !group(form, 2)) return;
    showAllSizes(form, variants);
    var o1 = current(form, 1), o2 = current(form, 2), o3 = current(form, 3);
    var ok = variants.some(function (v) { return v.option1 === o1 && v.option2 === o2 && (o3 === null || v.option3 === o3); });
    if (ok) return;
    var pick = variants.filter(function (v) { return v.option1 === o1 && (o3 === null || v.option3 === o3); })[0] ||
               variants.filter(function (v) { return v.option1 === o1; })[0];
    if (!pick) return;
    if (pick.option2 !== o2) choose(form, 2, pick.option2);
    if (o3 !== null && pick.option3 !== o3) choose(form, 3, pick.option3);
  }

  function fixAll() { document.querySelectorAll('form.product-single__form').forEach(fix); }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var wrap = t.closest('.variant-input-wrap');
    var form = t.closest('form.product-single__form');
    if (wrap && form) fix(form);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixAll); else fixAll();
  document.addEventListener('page:loaded', fixAll);
  document.addEventListener('quickshop:opened', function () { setTimeout(fixAll, 50); });
})();
